<template>
  <div>
    <div class="wrapper" v-bind:class="{ admin: managerMode }">
      <div id="specials-calendar" v-bind:class="{ admin: managerMode }">
        <div v-for="month in arrangedMonths" :key="month.monthNumber">
          <h1>{{ month.monthName }}</h1>
          <MonthlyCalendar class="month" :calMonth="month.monthNumber" v-bind:calData="specials"></MonthlyCalendar>
        </div>

        <div class="annotations">
          Specials:
          <div class="sp_sample sp_orange">Spring Special</div>
          <div class="sp_sample sp_blue">Summer Special</div>
          <div class="sp_sample sp_green">Fall Special</div>
          <div class="sp_sample sp_purple">Last Minute Special!</div>
          <div class="sp_sample sp_multiple">More than1 one Special</div>
        </div>
      </div>

      <!-- Manager -->
      <div v-if="managerMode" id="manager">
        <h2>Special Offers</h2>
        <h2>Campaigns</h2>
      </div>
    </div>

    <!-- <button v-on:click="managerMode = !managerMode">Admin</button> -->
  </div>
</template>

<script>
import MonthlyCalendar from "./components/MonthlyCalendar.vue";
import axios from "axios";
import moment from "moment";

export default {
  name: "specialOffers",
  data() {
    return {
      errors: [],
      specials: [],
      lastMinuteDates:[],
      managerMode: false,
        dateObj:  moment(),
      months: [
        { monthName: "January", monthNumber: "01" },
        { monthName: "February", monthNumber: "02" },
        { monthName: "March", monthNumber: "03" },
        { monthName: "April", monthNumber: "04" },
        { monthName: "May", monthNumber: "05" },
        { monthName: "June", monthNumber: "06" },
        { monthName: "July", monthNumber: "07" },
        { monthName: "August", monthNumber: "08" },
        { monthName: "September", monthNumber: "09" },
        { monthName: "October", monthNumber: "10" },
        { monthName: "November", monthNumber: "11" },
        { monthName: "December", monthNumber: "12" }
      ],
      currentMonth: new Date().getMonth(),
      menu: [
        {
          header: true,
          title: "Special Offers",
          hiddenOnCollapse: true,
          theme: "white-theme"
        },
        {
          href: "/",
          title: "Dashboard",
          icon: "fa fa-user"
        },
        {
          href: "/charts",
          title: "Charts",
          icon: "fa fa-chart-area",
          child: [
            {
              href: "/charts/sublink",
              title: "Sub Link"
            }
          ]
        }
      ]
    };
  },

  components: {
    MonthlyCalendar
  },
  created() {
    this.loadData();
    //console.log(this.currentMonth + 1);
    //console.log(this.arrangedMonths);
  },
  methods: {
    loadData() {
      // load a list of current guests / reservations
      axios
        .get(`https://playa-escondida.com/special-offers/specials.json`)
        .then(response => {
          this.specials = response.data;
          this.calculateLastMinute();
         // console.log(this.specials);
        })
        .catch(e => {
          this.errors.push(e);
        });
    },
    calculateLastMinute(){
      var startOfLastMinute = moment();
      var endOfLastMinute = moment().add(1, 'week');
     
      while(startOfLastMinute.add(1, 'days').diff(endOfLastMinute) <= 0) {
        let day = {
            "date":startOfLastMinute.format("YYYY-MMMM-DD"),
            "title":"Last Minute Special",
            "description": "Enjoy an even greater experience with our spring complements",
            "specialClass": "sp_purple"
        }
        this.lastMinuteDates.push(day);
    }
    this.specials = this.specials.concat(this.lastMinuteDates);

    }
  },
  computed: {
    arrangedMonths: function() {
      const sortedArray = [];
      for (
        let index = this.currentMonth + 1;
        index <= this.months.length;
        index++
      ) {
        const element = this.months[index - 1];
        if (sortedArray.length < this.months.length) {
          sortedArray.push(element);
        }

        /* console.log("index", index);
        console.log(element);
        console.log("months lenght", this.months.length);
        console.log("sorted lenght: ", sortedArray.length); */

        if (
          index == this.months.length &&
          sortedArray.length < this.months.length
        ) {
          //console.log("time to reset counter");
          index = 0;
        }
      }
      return sortedArray;
    }
  }
};
</script>

<style>
body {
  padding: 0px;
  margin: 0px;
}
#app {
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
#manager {
  border: 1px solid red;
  height: 100%;
  background-color: white;
  width: 40%;
}
#specials-calendar.admin {
  width: 60%;
}
.admin {
}
.wrapper.admin {
  /*  display: grid;
  grid-auto-rows: auto;
  grid-gap: 10px;
  background-color: #fff;
  color: #444; */
  display: flex;
}
.sp_blue {
  background-color: #049698;
  color: white;
}
.sp_green {
  background-color: #a0b351;
  color: white;
}
.sp_red {
  background-color: #df5b4c;
  color: white;
}
.sp_purple {
  background-color: #ce93d8;
  color: white;
}
.sp_multiple {
  color: tomato;
  background: linear-gradient(45deg, #fdcd3b 50%, #ffed4b 50%);
}
.sp_sample {
  height: 40px;
  line-height: 2.5em;
  text-align: center;
  vertical-align: middle;
}

/*
.dot {
  height: 25px;
  width: 25px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
}
  */
@media only screen and (min-device-width: 375px) and (max-device-width: 667px) {
  .annotations {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    color: gray;
    text-align: center;
  }
  body {
    margin-bottom: 220px;
  }
}
</style>
